import React from "react";

export default function GarryOverlay({ phase }) {
  if (!phase) return null;
  return (
    <>
      <img
        src="/garry.png"
        alt=""
        className={`garry-anim ${phase === "enter" ? "garry-enter" : phase === "pause" || phase === "reject" ? "garry-paused" : phase === "lead" || phase === "exit" ? "garry-exit" : ""}`}
        draggable={false}
      />
      {phase === "reject" && (
        <div className="rejection-overlay">
          <img src="/rejection.png" alt="YC Rejection" className="rejection-img" draggable={false} />
        </div>
      )}
    </>
  );
}
